module.exports = __webpack_public_path__ + "05c11fe018a33af6eb0ab64b80201aba.png";


//////////////////
// WEBPACK FOOTER
// ../assets/tripitty-screen.png
// module id = 526
// module chunks = 0